export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-7e-62cd982b0b501089e080be58f9cefbe8.webp";